import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from './components/ConfigContext.js';
import './index.css';
import './tailwind.css';
import App from './App.js';
import reportWebVitals from './reportWebVitals.js';
import './utils/utmKeeper.js';

const rootElement = document.getElementById('root');
const appTree = (
  <React.StrictMode>
     <ConfigProvider>
      <App />
    </ConfigProvider>
  </React.StrictMode>
);

// Pre-rendered routes (react-snap) leave real markup inside #root — hydrate it
// instead of re-rendering from scratch, otherwise the pre-rendered HTML is discarded.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, appTree);
} else {
  ReactDOM.createRoot(rootElement).render(appTree);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
